import React from "react";
import styled, { css } from "styled-components";

import { Text } from "src/library/components/Text";
import { Icon } from "src/library/components/Icon";
import { Icons } from "src/library/components/Icon/types";
import { IProduct } from "src/core/products/api/products.api";

interface SelectedProductCardProps {
  product: IProduct;
  icon: Icons;
  onClick: () => void;
}

export const SelectedProductCard: React.ReactFCWithChildren<SelectedProductCardProps> = ({
  product,
  icon,
  onClick
}) => (
  <SelectedProductCardWrapper>
    <Text
      weight="bold"
      color="secondary"
    >
      {product.partNumber}
    </Text>

    <Text>
      {product.description}
    </Text>

    <Icon
      icon={icon}
      size={24}
      onClick={onClick}
    />
  </SelectedProductCardWrapper>
);

const SelectedProductCardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 1.2rem;
  padding-right: 0.6rem;
  height: 40px;
  transition: 0.25s all ease;
  width: 32rem;

  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    border: 2px solid transparent;
    border-radius: ${theme.borderRadius};

    &:hover {
      border-color: ${theme.colors.primaryDark};
    }
  `}

  ${Text} {
    margin-right: 1rem;
  }

  svg {
    margin-left: auto;
  }
`;
